import { Link } from "react-router";
import type { Language } from "../config/site";
import { homeContent } from "../content/home";
import { CodeMotif } from "../components/CodeMotif";

export function HomePage({ language }: { language: Language }) {
  const copy = homeContent[language];
  const prefix = language === "tr" ? "/tr" : "";

  return (
    <>
      <section className="hero marketing-width">
        <div className="hero__copy">
          <p className="eyebrow"><span />{copy.eyebrow}</p>
          <h1>{String(copy.headline).split("\n").map((line) => <span key={line}>{line}</span>)}</h1>
          <p className="hero__intro">{copy.intro}</p>
          <div className="hero__actions">
            <a className="button button--primary" href="#daily-vault">{copy.primaryAction}</a>
            <Link className="button button--quiet" to={`${prefix}/support/`}>{copy.secondaryAction}</Link>
          </div>
        </div>
        <div className="hero__visual"><CodeMotif /></div>
      </section>

      <section className="feature-section marketing-width" id="daily-vault">
        <article className="feature-card feature-card--daily">
          <p className="eyebrow">{copy.dailyLabel}</p>
          <h2>{copy.dailyTitle}</h2>
          <p>{copy.dailyBody}</p>
          <div className="cycle-line"><span>16:00</span><small>UTC</small><i /></div>
        </article>
        <article className="feature-card">
          <p className="eyebrow">{copy.practiceLabel}</p>
          <h2>{copy.practiceTitle}</h2>
          <p>{copy.practiceBody}</p>
          <div className="difficulty-list">
            {(copy.difficulties as string[]).map((difficulty, index) => (
              <span key={difficulty}><b>{difficulty}</b><i>{Array.from({ length: index + 4 }, (_, digit) => <em key={digit} />)}</i></span>
            ))}
          </div>
        </article>
      </section>

      <section className="principles marketing-width" aria-label={language === "tr" ? "VaultPin ilkeleri" : "VaultPin principles"}>
        <article><span className="principle-number">01</span><h2>{copy.purchaseTitle}</h2><p>{copy.purchaseBody}</p></article>
        <article><span className="principle-number">02</span><h2>{copy.privacyTitle}</h2><p>{copy.privacyBody}</p></article>
      </section>

      <section className="web-note marketing-width">
        <div className="web-note__mark" aria-hidden="true">W</div>
        <div><p className="eyebrow">VAULTPIN.APP</p><h2>{copy.webTitle}</h2><p>{copy.webBody}</p></div>
        <Link className="text-link" to={`${prefix}/play/`}>{copy.webAction}<span aria-hidden="true">→</span></Link>
      </section>
    </>
  );
}
